import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface State {
    optionsBasic: {
        id:string;
        label:string;
    }[] | null;
    optionsCheckout: {
        id:string;
        label:string;
    }[] | null;
    optionsAddress: {
        id:string;
        label:string;
    }[] | null;
    optionsContainer: {
        id:string;
        label:string;
    }[] | null;
    optionsFile: {
        id:string;
        label:string;
    }[] | null;
    optionsTape: {
        id:string;
        label:string;
    }[] | null;
    searchText: string | null;
    selectedValues: {
        level1: string;
        level2: string;
        level3: string;
    } | null;
    searchBasicFormText: string | null;
    searchCheckoutFormText: string | null;
    searchAddressFormText: string | null;
    searchContainerFormText: string | null;
    searchFileFormText: string | null;
    searchTapeFormText: string | null;
    selectedValuesBasicForm: {
        level1: string;
        level2: string;
        level3: string;
    } | null;
    selectedValuesCheckoutForm: {
        level1: string;
        level2: string;
        level3: string;
    } | null;
    selectedValuesAddressForm: {
        level1: string;
        level2: string;
        level3: string;
    } | null;
    selectedValuesContainerForm: {
        level1: string;
        level2: string;
        level3: string;
    } | null;
    selectedValuesFileForm: {
        level1: string;
        level2: string;
        level3: string;
    } | null;
    selectedValuesTapeForm: {
        level1: string;
        level2: string;
        level3: string;
    } | null;
}

const initialState: State = {
    optionsBasic:null,
    optionsAddress:null,
    optionsCheckout:null,
    optionsContainer:null,
    optionsFile:null,
    optionsTape:null,
    searchText: null,
    selectedValues: null,
    searchBasicFormText: null,
    selectedValuesBasicForm: null,
    searchAddressFormText: null,
    selectedValuesAddressForm: null,
    searchCheckoutFormText: null,
    selectedValuesCheckoutForm: null,
    searchContainerFormText: null,
    selectedValuesContainerForm: null,
    searchFileFormText: null,
    selectedValuesFileForm: null,
    searchTapeFormText: null,
    selectedValuesTapeForm: null
}

export const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        setOptionsBasic: (state, action: PayloadAction<{
            id:string;
            label:string;
        }[] | null>) => {
            state.optionsBasic = action.payload;
        },

        setOptionsAddress: (state, action: PayloadAction<{
            id:string;
            label:string;
        }[] | null>) => {
            state.optionsAddress = action.payload;
        },

        setOptionsCheckout: (state, action: PayloadAction<{
            id:string;
            label:string;
        }[] | null>) => {
            state.optionsCheckout = action.payload;
        },

        setOptionsContainer: (state, action: PayloadAction<{
            id:string;
            label:string;
        }[] | null>) => {
            state.optionsContainer = action.payload;
        },

        setOptionsFile: (state, action: PayloadAction<{
            id:string;
            label:string;
        }[] | null>) => {
            state.optionsFile = action.payload;
        },

        setOptionsTape: (state, action: PayloadAction<{
            id:string;
            label:string;
        }[] | null>) => {
            state.optionsTape = action.payload;
        },

        setSearchBasicFormText: (state, action: PayloadAction<string | null>) => {
            state.searchBasicFormText = action.payload;
        },

        setSelectedValuesBasicForm: (state, action: PayloadAction<{
            "level1": string;
            "level2": string;
            "level3": string;
        } | null>) => {
            state.selectedValuesBasicForm = action.payload;
        },

        setSearchAddressFormText: (state, action: PayloadAction<string | null>) => {
            state.searchAddressFormText = action.payload;
        },

        setSelectedValuesAddressForm: (state, action: PayloadAction<{
            "level1": string;
            "level2": string;
            "level3": string;
        } | null>) => {
            state.selectedValuesAddressForm = action.payload;
        },

        setSearchCheckoutFormText: (state, action: PayloadAction<string | null>) => {
            state.searchCheckoutFormText = action.payload;
        },

        setSelectedValuesCheckoutForm: (state, action: PayloadAction<{
            "level1": string;
            "level2": string;
            "level3": string;
        } | null>) => {
            state.selectedValuesCheckoutForm = action.payload;
        },

        setSearchContainerFormText: (state, action: PayloadAction<string | null>) => {
            state.searchContainerFormText = action.payload;
        },

        setSelectedValuesContainerForm: (state, action: PayloadAction<{
            "level1": string;
            "level2": string;
            "level3": string;
        } | null>) => {
            state.selectedValuesContainerForm = action.payload;
        },

        setSearchFileFormText: (state, action: PayloadAction<string | null>) => {
            state.searchFileFormText = action.payload;
        },

        setSelectedValuesFileForm: (state, action: PayloadAction<{
            "level1": string;
            "level2": string;
            "level3": string;
        } | null>) => {
            state.selectedValuesFileForm = action.payload;
        },

        setSearchTapeFormText: (state, action: PayloadAction<string | null>) => {
            state.searchTapeFormText = action.payload;
        },

        setSelectedValuesTapeForm: (state, action: PayloadAction<{
            "level1": string;
            "level2": string;
            "level3": string;
        } | null>) => {
            state.selectedValuesTapeForm = action.payload;
        },
    }
})

export const {
    setOptionsBasic, setOptionsAddress, setOptionsCheckout, setOptionsContainer, setOptionsFile, setOptionsTape,
    setSearchBasicFormText, setSelectedValuesBasicForm, setSearchAddressFormText, setSelectedValuesAddressForm,
    setSearchCheckoutFormText, setSelectedValuesCheckoutForm,
    setSearchContainerFormText, setSelectedValuesContainerForm,
    setSearchFileFormText, setSelectedValuesFileForm,
    setSearchTapeFormText, setSelectedValuesTapeForm
} = searchSlice.actions

export default searchSlice.reducer
